import m from "../../es2015/lang/uk_UA";
window.am4lang_uk_UA = m;


//////////////////
// WEBPACK FOOTER
// ./lang/uk_UA.js
// module id = null
// module chunks = 